import * as request from '@/utils/request'

/**
 * 列表
 * @param data
 * @returns {Promise}
 */
export function tradeStatsCommissionList(data) {
  return request.post('/trade_stats_commission/list', data)
}

export function tradeStatsCommissionChart(data) {
  return request.post('/trade_stats_commission/chart', data)
}


export function tradeStatCommissionInit(data) {
  return request.post('/trade_stats_commission/init_stat', data)
}
